import Vue from 'vue'
import VueMatomo from 'vue-matomo'
import {
  checkToken
} from '../common/helper'
export async function requestPiwik(router) {
  let check = await checkToken();
  if (check) {
    let userEmail = Vue.$cookies.get("userEmail");
    var emailAccount = userEmail ? userEmail.toLowerCase() : "guest";
    
    // console.log('requestPiwik', emailAccount);
    Vue.use(VueMatomo, {
      host: 'https://analytics.fsoft.com.vn',
      siteId: 150,
      trackerFileName: 'piwik',
      router: router,
      enableLinkTracking: true,
      requireConsent: false,
      trackInitialView: true,
      disableCookies: false,
      enableHeartBeatTimer: false,
      heartBeatTimerInterval: 15,
      debug: false,
      userId: emailAccount,
      preInitActions: []
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/piwikRequest.js